export const roles = Object.freeze({
  all: {value: 1, name: "", shortName: "", distinct: false,},
  anon: {value: 2, name: "", shortName: "", distinct: false,},
  admin: {value: 4, name: "Admin", shortName: "AD", distinct: true,},
  cv: {value: 8, name: "CCTV", shortName: "TV", distinct: true,},
  moderator: {value: 16, name: "Moderator", shortName: "MD", distinct: true,},
  shelter: {value: 32, name: "Shelter", shortName: "S", distinct: true,},
  shelterPlus: {value: 64, name: "Shelter+", shortName: "S+", distinct: true,},
  hostes: {value: 128, name: "Hostes", shortName: "MI", distinct: true,},
});